export default {
  // 主题基本信息
  code: 'kpzp',
  name: '全国优质科普作品征集',
  description: '2026全国优质科普作品征集活动',
  
  // 路由配置
  routeBase: '/kpzp',
  
  // 主题路由定义
  routes: [
    { path: '', component: 'Promo', meta: { title: '首页' } },
    { path: 'gallery', component: 'Gallery', meta: { title: '作品展示' } },
    { path: 'work-submit', component: 'WorkSubmit', meta: { title: '提交作品' }, auth: true },
    { path: 'work/detail/:id', component: 'WorkDetail', meta: { title: '作品详情' }, auth: true },
    { path: 'print-preview/:id', component: 'PrintPreview', meta: { title: '打印预览' }, auth: true },
    { path: 'user/center', component: 'UserCenter', meta: { title: '个人中心' }, auth: true },
    { path: 'my-works', component: 'MyWorks', meta: { title: '我的作品' }, auth: true },
    { path: 'login', component: 'Login', meta: { title: '登录' } },
    { path: 'register', component: 'Register', meta: { title: '注册' } }
  ],
  
  // 主题样式 - index-v3 蓝色系
  themeColor: '#1565c0',
  secondaryColor: '#00ACC1',
  
  // API配置
  apiPrefix: '/portal',
  
  // 扩展配置
  extra: {
    organization: '全民科学素质纲要实施工作办公室',
    location: '中国科学技术协会',
    year: 2026,
    contactEmail: 'kepu@cast.org.cn',
    activityPeriod: '2026.5—9'
  }
}
